// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__1Weie","shimmer":"Skeleton_shimmer__1AcqC","barGroup":"Skeleton_barGroup__W_YFZ","bar":"Skeleton_bar__1gS5N"};